import { interimSchoolIdAtom } from '@/atom'
import { reflectionStorage, schoolIdStorage, store } from '@/store'
import { State, Toast } from '@seiue/ui'
import { useOnMount, isNaN } from '@seiue/util'
import { useSetAtom } from 'jotai'
import React from 'react'

/**
 * 过渡页
 *
 * @returns 过渡页
 */
export const Interim: React.FC = () => {
  const setInterimSchoolIdAtom = useSetAtom(interimSchoolIdAtom)
  useOnMount(() => {
    const reflection = store.get(reflectionStorage)
    const schoolId = store.get(schoolIdStorage)

    const regex = /\/interim\/(.*)/
    const result = location.pathname.match(regex)
    const urlSchoolIdRaw = result?.[1]

    if (!urlSchoolIdRaw) {
      Toast.error('未找到学校信息，请确认登录链接是否正确')
      location.href = '/404'
      return
    }

    // 处理 URL 编码的情况，提取纯数字部分
    let decodedSchoolId: string
    try {
      decodedSchoolId = decodeURIComponent(urlSchoolIdRaw)
    } catch {
      decodedSchoolId = urlSchoolIdRaw
    }

    // 提取第一个连续的数字部分
    const match = decodedSchoolId.match(/^(\d+)/)
    const urlSchoolId = match?.[1]

    if (!urlSchoolId || isNaN(Number(urlSchoolId))) {
      Toast.error('未找到学校信息，请确认登录链接是否正确')
      location.href = '/404'
      return
    }

    const numericSchoolId = Number(urlSchoolId)
    // 有时候 schoolId 存储在 store 时导致数据获取不及时，这里单独存储
    setInterimSchoolIdAtom(numericSchoolId)
    store.set(schoolIdStorage, numericSchoolId)
    if (numericSchoolId !== schoolId || !reflection) {
      location.href = `/login/${urlSchoolId}`
    } else {
      location.href = '/'
    }
  })

  return <State.Loading />
}
